module.exports = __webpack_public_path__ + "img/escola.418efb48.webp";